import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../../layout/theme/utils/colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    uploadArea: {
      border: `1px dashed ${Colors.blue}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(4),
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: Colors.light_blue2,
      },
    },
    uploadIcon: {
      fontSize: 28,
      color: Colors.font_gray,
      marginBottom: theme.spacing(1),
    },
    uploadText: {
      color: Colors.font_gray,
      marginBottom: theme.spacing(0.5),
    },
    chooseFileLink: {
      fontWeight: 700,
      color: Colors.blue,
    },
    uploadSubtext: {
      color: Colors.hint_gray,
      fontSize: 12,
    },
    fileInput: {
      display: 'none',
    },
    currentFileLabel: {
      color: Colors.hint_gray,
      fontWeight: 'bold',
    },
    currentFileName: {
      marginTop: theme.spacing(0.5),
      '& a': {
        color: Colors.blue,
      },
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    textautosizer: {
      width: '-webkit-fill-available',
      borderRadius: theme.spacing(0.5),
      borderColor: Colors.hint_gray,
      color: Colors.dark_gray,
    },
    label: {
      margin: theme.spacing(3, 0, 3, 0),
      fontWeight: 'bold',
      color: Colors.dark_gray,
    },
    sizeLabel: {
      fontWeight: 'normal',
      color: Colors.hint_gray,
    },
    previewImage: {
      maxWidth: '100%',
      maxHeight: '80vh',
    },
    previewTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    previewDownloadButton: {
      padding: 0,
    },
  }),
);
